module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1530-1b4464ec277142a337bf6f3777b85675.png";